/**
 * Copyright © 2012 Goodgame Studios. All rights reserved.
 *
 * Created with IntelliJ IDEA
 * Creator: pburst
 * Created: 21.01.13, 09:13
 *
 * $URL: $
 * $Rev: $
 * $Author: $
 * $Date: $
 * $Id: $
 */

export class GGSVerticalAlign {
    public static BOTTOM: string = "bottom";
    public static JUSTIFY: string = "justify";
    public static MIDDLE: string = "middle";
    public static TOP: string = "top";
}


// TODO @HTML5  HTML-2128 check textBaseline The vertical alignment point on the font. Any of "top", "hanging", "middle", "alphabetic", "ideographic", or "bottom".   from Text EaselJS